/**
 * @fileoverview Access to RCSB APIs
 */

/**
 * @param {string} ccdCode
 */
export async function getCCDSmiles(ccdCode) {
    const url = `https://data.rcsb.org/rest/v1/core/chemcomp/${ccdCode}`;
    const response = await fetch(url);

    if (!response.ok) {
        return { errors: [`Error interpreting ${ccdCode}: Are you sure it is a valid ccd code?`] };
    }

    const data = await response.json();
    // Try a few things in order: RCSB's version, OpenEye's version, and then a generic fallback
    let smiles = data.rcsb_chem_comp_descriptor?.smiles;
    if (!smiles) {
        smiles = data.pdbx_chem_comp_descriptor?.find(
            (e) => e.type === 'SMILES' && e.program === 'OpenEye OEToolkits'
        )?.descriptor;
    }
    if (!smiles) {
        smiles = data.pdbx_chem_comp_descriptor?.find(
            (e) => ['SMILES', 'SMILES_CANONICAL'].includes(e.type)
        )?.descriptor;
    }

    return smiles ? { smiles } : { errors: [`No SMILES found for ${ccdCode}`] };
}
